import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";

import inboxService from "venuescanner-js/react/components/Inbox/services/inboxService";

const MatchAccept = ({
  match,
  newMatchThreadId,
  setNewMatchThreadId,
  viewNewMatchEnquiry,
}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    inboxService
      .leadAccept({
        _id: match._id,
        message: `${match.organiser.name} is interested in holding their event at ${match.venue.name}`,
      })
      .then((res) => {
        const { data } = res;
        setNewMatchThreadId(data.thread);
        setLoading(false);
      })
      .catch((err) => {
        console.log("MatchAccept: leadAccept error - ", err);
        setNewMatchThreadId("error");
        setLoading(false);
      });
  }, []);

  return (
    <div className="match-accept">
      <div className="match-accept__wrapper">
        {loading ? (
          <span className="loading" />
        ) : newMatchThreadId === "error" ? (
          <>
            <span className="h2">&#9995;</span>
            <h3 className="match-accept__title">Woops...</h3>
            <p className="match-accept__copy">
              There seems to have been an error accepting this Venue, please
              refresh the page and try again or contact one of our team
            </p>
            <div className="match-accept__ctas">
              <span className="p" onClick={() => Intercom("show")}>
                Contact us
              </span>
            </div>
          </>
        ) : (
          <>
            <span className="h2">&#127881;</span>
            <h3 className="match-accept__title">It's a match!</h3>
            <p className="match-accept__copy">
              You can now contact {match.venue.name} to discuss any questions or
              details that are outstanding using the Enquiries tab
            </p>
            <div className="match-accept__ctas">
              <button
                className="button button--light"
                onClick={() => viewNewMatchEnquiry()}
              >
                Contact {match.venue.name}
              </button>
              <Link to="/inbox/matches">
                <span className="p">Continue with matches</span>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MatchAccept;
